import React, { useEffect, useRef } from 'react';
import PromptGenerator from './PromptGenerator';
import './PromptGenerator.css';

const PromptGeneratorModal = ({ isOpen, onClose, onDropIn }) => {
    const modalRef = useRef(null);
    const contentRef = useRef(null);

    // Handle ESC key
    useEffect(() => {
        if (!isOpen) return;
        
        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [isOpen, onClose]);

    // Change button text and intercept clicks
    useEffect(() => {
        if (!isOpen || !contentRef.current) return;

        // Change button text to "Drop in page"
        const updateButtonText = () => {
            const button = contentRef.current.querySelector('.ai-button');
            if (button && button.textContent.trim() === 'Send to AI Page') {
                button.textContent = 'Drop in page';
            }
        };

        // Use MutationObserver to catch when button is rendered
        const observer = new MutationObserver(() => {
            updateButtonText();
        });

        observer.observe(contentRef.current, {
            childList: true,
            subtree: true,
            characterData: true
        });

        // Initial update
        setTimeout(updateButtonText, 100);

        const handleClick = (e) => {
            const button = e.target.closest('.ai-button');
            if (button && (button.textContent.trim() === 'Drop in page' || button.textContent.trim() === 'Send to AI Page')) {
                e.preventDefault();
                e.stopPropagation();
                
                // Find the generated prompt from the textarea
                const textarea = contentRef.current.querySelector('.prompt-textarea');
                if (textarea && onDropIn) {
                    const promptText = textarea.value.trim();
                    if (promptText) {
                        onDropIn(promptText);
                        onClose();
                    }
                }
                return false;
            }
        };

        const content = contentRef.current;
        content.addEventListener('click', handleClick, true);
        
        return () => {
            observer.disconnect();
            content.removeEventListener('click', handleClick, true);
        };
    }, [isOpen, onClose, onDropIn]);

    if (!isOpen) return null;

    return (
        <div 
            ref={modalRef}
            className="prompt-generator-modal-overlay" 
            onClick={onClose}
        >
            <div 
                ref={contentRef}
                className="prompt-generator-modal-content" 
                onClick={(e) => e.stopPropagation()}
            >
                <div className="prompt-generator-modal-header">
                    <h2>Prompt Generator</h2>
                    <button 
                        className="prompt-generator-modal-close" 
                        onClick={onClose}
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>
                <div className="prompt-generator-modal-body">
                    <PromptGenerator isModal={true} />
                </div>
            </div>
        </div>
    );
};

export default PromptGeneratorModal;
